export const links = {
	swanseaUni: 'https://www.swansea.ac.uk/',
	swanseaUniCy: 'https://www.swansea.ac.uk/cy',
	tteApp: 'https://www.swansea.ac.uk/',
	// Socials
	twitter: 'https://twitter.com/SwanseaUni',
	instagram: 'https://www.instagram.com/swanseauni',
	facebook: 'https://www.facebook.com/swanseauniversity',
}